import type { IBygg } from './IBygg';

export class Bygg implements IBygg {
    private _byggId: string;
    private _adresse: string;
    private _beskrivelse: string;
    private _byggeAar: string;
    private _byggNummer: string;
    private _eiendomsNummer: string;
    private _etasjer: string;
    private _navn: string;
    private _driftsansv: string;
    private _driftsteknikker: string;
    private _eiendomsansv: string;
    private _gabNummer: string;
    private _kompleksNummer: string;
    private _hovedVisningsBilde: string;
    private _latitude: number;
    private _longitude: number;
    private _totAreal: number;
    private _totArealUnits = 'm²';
    private _andelFossilEl: number;
    private _andelFossilElUnits = '%';
    private _energiForbruk: number;
    private _energiForbrukUnits = 'kWh/m²';

    private _energiKarakter: IBygg['energiKarakter'];

    public get byggId() {
        return this._byggId;
    }

    public get adresse() {
        return this._adresse;
    }

    public get beskrivelse() {
        return this._beskrivelse;
    }

    public get byggeAar() {
        return this._byggeAar;
    }

    public get byggNummer() {
        return this._byggNummer;
    }

    public get eiendomsNummer() {
        return this._eiendomsNummer;
    }

    public get etasjer() {
        return this._etasjer;
    }

    public get navn() {
        return this._navn;
    }

    public get driftsansv() {
        return this._driftsansv;
    }

    public get driftsteknikker() {
        return this._driftsteknikker;
    }

    public get eiendomsansv() {
        return this._eiendomsansv;
    }

    public get gabNummer() {
        return this._gabNummer;
    }

    public get kompleksNummer() {
        return this._kompleksNummer;
    }

    public get hovedVisningsBilde() {
        return this._hovedVisningsBilde;
    }

    public get latitude() {
        return this._latitude;
    }

    public get longitude() {
        return this._longitude;
    }

    public get totAreal() {
        return this._totAreal;
    }
    public get totArealUnits() {
        return this._totArealUnits;
    }

    public get andelFossilEl() {
        return this._andelFossilEl;
    }
    public get andelFossilElUnits() {
        return this._andelFossilElUnits;
    }

    public get energiForbruk() {
        return this._energiForbruk;
    }
    public get energiForbrukUnits() {
        return this._energiForbrukUnits;
    }

    public get energiKarakter() {
        return this._energiKarakter;
    }

    public static parseObject(obj: IBygg): Bygg {
        try {
            return new Bygg(obj);
        } catch (error) {
            throw new Error(
                `Not able to parse Bygg object, object attempted to parse were: ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }

    constructor(obj: IBygg) {
        this._adresse = obj.adresse;
        this._beskrivelse = obj.beskrivelse;
        this._byggId = obj.byggId;
        this._byggNummer = obj.byggNummer;
        this._byggeAar = obj.byggeAar;
        this._eiendomsNummer = obj.eiendomsNummer;
        this._etasjer = obj.etasjer;
        this._navn = obj.navn;
        this._driftsansv = obj.driftsansv;
        this._driftsteknikker = obj.driftsteknikker;
        this._eiendomsansv = obj.eiendomsansv;
        this._gabNummer = obj.gabNummer;
        this._kompleksNummer = obj.kompleksNummer;
        this._hovedVisningsBilde = obj.hovedVisningsBilde;
        this._latitude = obj.latitude;
        this._longitude = obj.longitude;
        this._totAreal = obj.totAreal;
        this._andelFossilEl = obj.andelFossilEl;
        this._energiForbruk = obj.energiForbruk;
        this._energiKarakter = obj.energiKarakter;
    }
}
